import gql from "graphql-tag";
const DELETE_EMAILS_FOOTERS = gql `
  mutation deleteEmailsFooter($id: ID!) {
    deleteEmailsFooter(id: $id) {
      status
    }
  }
`;
export default DELETE_EMAILS_FOOTERS;
